import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg24SwapCoin = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      d: "m4.637 9.459.052.018a.8.8 0 0 1 .246.157l2.57 2.39a.8.8 0 1 1-1.09 1.172l-1.201-1.117a6.53 6.53 0 0 0 4.272 6.53 6.51 6.51 0 0 0 7.418-2.154.8.8 0 0 1 1.272.97 8.11 8.11 0 0 1-9.242 2.686 8.13 8.13 0 0 1-5.33-7.868l-1.017 1.1a.8.8 0 0 1-1.174-1.087l2.385-2.574.053-.052.039-.035a.8.8 0 0 1 .747-.136m9.649-4.76a8.13 8.13 0 0 1 5.33 7.86l1.018-1.094a.8.8 0 1 1 1.172 1.09l-2.4 2.58a.8.8 0 0 1-.501.25l-.112.004a.8.8 0 0 1-.518-.213l-2.57-2.39a.8.8 0 1 1 1.09-1.172l1.21 1.125a6.53 6.53 0 0 0-4.27-6.538 6.51 6.51 0 0 0-7.419 2.154.8.8 0 1 1-1.272-.97 8.11 8.11 0 0 1 9.242-2.686"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg24SwapCoin$1 = Svg24SwapCoin;

export { Svg24SwapCoin$1 as default };
